import { useContext } from 'react';

import type { PageContextProps } from '../contexts/PageContext.js';
import { PageContext } from '../contexts/PageContext.js';

/** Hook for accessing the PageContext.
 * @internal
 */
export const usePageContext = (): PageContextProps => {
  return useContext(PageContext);
};
